import { Observable} from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { SendGTMEvent, TagManagerAction, TagManagerActions } from '../actions/tagManager.action';

const sendGTMEvent = (action$: Observable<TagManagerAction>) => action$.pipe(
  ofType<SendGTMEvent>(TagManagerActions.SendGTMEvent),
  switchMap((action) => new Observable(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(action.payload);
  })),
);

export default [
  sendGTMEvent,
];
